import { FC } from 'react';

import GenericTable from '../table';
import { IColumnDescriptor } from '../table/types';

import { useAppSelector } from '../../hooks/redux';
import { IPlanHistory, PaymentStatus } from '../../store/planHistory.slice';

const formatNumber = (val?: number) => new Intl.NumberFormat('ru-RU').format(val ? val : 0);

const paymentHistoryColumns: IColumnDescriptor<IPlanHistory>[] = [
  {
    header: 'Дата',
    key: 'updated_at',
    align: 'center',
    render: (row) => new Date(row.updated_at).toLocaleDateString(),
  },
  {
    header: 'Статус',
    key: 'payment_status',
    align: 'center',
    // Специальный рендеринг для добавления символа рубля
    render: (row) => {
      switch (row.payment_status) {
        case PaymentStatus.SUCCESS:
          return 'Успешно';
        case PaymentStatus.REFUND:
          return 'Возврат';
        default:
          return 'Отклонено';
      }
    },
  },
  {
    header: 'Списанная сумма',
    key: 'total_paid',
    align: 'center',
    // Специальный рендеринг для добавления символа рубля
    render: (row) => `${formatNumber(row.total_paid)} ${row.currency_symbol}`,
  },
  {
    header: 'Бонусные рубли',
    key: 'bonus_used',
    align: 'center',
    render: (row) => formatNumber(row.bonus_used),
  },
  {
    header: 'Тариф',
    key: 'plan_name',
    align: 'center',
  },
  {
    header: 'Способ оплаты',
    key: 'payment_description',
    align: 'center',
  },
];

export const PaymentHistory: FC = () => {
  const transactions = useAppSelector((s) => s.planHistorySlice);

  return (
    <div className="flex flex-col gap-2">
      <p className="text-heading-lg font-medium">История платежей</p>
      {transactions.history.length <= 0 && <p className="text-body-l text-ink-muted">Пока у вас не было платежей.</p>}
      {transactions.history.length > 0 && <GenericTable columns={paymentHistoryColumns} data={transactions.history} />}
    </div>
  );
};
